import { Grid, Paper, Typography } from "@material-ui/core";
// Lib
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import classNames from "classnames";
import React from "react";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { version } from "../../../utils/setting";
import { styles } from "./styles";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const timeBlock = [];
for (let i = 7; i <= 11; i++) {
  timeBlock.push(`${i}:00 AM`);
}
timeBlock.push(`12:00 PM`);
for (let i = 1; i <= 10; i++) {
  timeBlock.push(`${i}:00 PM`);
}

class EmployeeReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getFormatDate = (date) => moment(date).format("DD/MM/YYYY");
  getTotalBonus = () => {
    const { t, setting, bonusEmployee, listOrders, oneEmployee } = this.props;
    let totalBonus = 0;

    listOrders.forEach((order) => {
      let listItem = order.item.filter((item) => {
        let isHaveEmployee =
          item.employee &&
          item.employee.find(
            (employee) => employee.userCode == oneEmployee.userCode
          );
        return !!isHaveEmployee;
      });
      if (listItem.length > 0) {
        listItem.forEach((item) => {
          let bonusItem = bonusEmployee.find(
            (bonus) =>
              bonus.itemCode == item.itemCode &&
              bonus.orderCode == order.orderCode
          ); // kiểm tra trong đơn hàng này nhân viên có đc bonus ko
          if (bonusItem) {
            totalBonus += bonusItem.bonusTotal;
          }
        });
      }
    });
    return totalBonus;
  };
  renderRowReport = () => {
    const {
      classes,
      t,
      setting,
      bonusEmployee,
      listOrders,
      oneEmployee,
    } = this.props;
    let STT = 0;
    return listOrders.map((order, index) => {
      let listItem = order.item.filter((item) => {
        let isHaveEmployee =
          item.employee &&
          item.employee.find(
            (employee) => employee.userCode == oneEmployee.userCode
          );
        return !!isHaveEmployee;
      });
      if (listItem.length == 0) return;
      return listItem.map((item, indexItem) => {
        let bonusItem = bonusEmployee.find(
          (bonus) =>
            bonus.itemCode == item.itemCode &&
            bonus.orderCode == order.orderCode
        ); // kiểm tra trong đơn hàng này nhân viên có đc bonus ko
        let bonusType = 0;
        if (bonusItem) {
          bonusType =
            bonusItem.typeBonus == "percent" ? (
              `${bonusItem.bonus * 100}%`
            ) : (
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={bonusItem.bonus}
              />
            );
        }
        let commissionBonus = bonusItem ? bonusItem.bonusTotal : 0;
        STT++;
        return (
          <Grid container spacing={24} key={`${index}-${indexItem}`}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              className={classNames(classes.rowReportEmployee)}
            >
              <Grid container spacing={24}>
                <Grid
                  className={classNames(classes.header)}
                  item
                  xs={1}
                  sm={1}
                  md={1}
                >
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {STT}
                  </Typography>
                </Grid>
                <Grid
                  className={classNames(classes.header)}
                  item
                  xs={3}
                  sm={3}
                  md={3}
                >
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {order.orderCode}
                  </Typography>
                </Grid>
                <Grid
                  className={classNames(classes.header)}
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {item.itemName}
                  </Typography>
                </Grid>
                <Grid
                  className={classNames(classes.header)}
                  item
                  xs={2}
                  sm={2}
                  md={2}
                >
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {item.quantity}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              className={classNames(classes.rowReportEmployee)}
            >
              <Grid container spacing={24}>
                <Grid item xs={3} sm={3} md={3}>
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {moment(order.createdAt).format("DD MMM YYYY")}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    <NumberFormat
                      suffix={` ${setting.currencyCode}`}
                      thousandSeparator={true}
                      displayType={"text"}
                      value={item.itemPrice * item.quantity}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <Typography
                    className={classNames(classes.textLeft, classes.fs14)}
                  >
                    {bonusType}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <Typography
                    className={classNames(
                      classes.textRight,
                      classes.mr1,
                      classes.fs14
                    )}
                  >
                    <NumberFormat
                      suffix={` ${setting.currencyCode}`}
                      thousandSeparator={true}
                      displayType={"text"}
                      value={commissionBonus}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      });
    });
  };
  render() {
    const { classes, t, datetime, oneEmployee, setting } = this.props;
    let data = {
      from: moment(datetime).startOf("month").valueOf(),
      to: moment(datetime).endOf("month").valueOf(),
    };
    return (
      <React.Fragment>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={12} className={classes.content}>
            <Paper className={classes.rootLandscape}>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textLeft]}>
                    {moment(new Date()).format("DD/MM/YYYY  h:mm A")}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textRight]}>
                    Masspa {version}
                  </Typography>
                </Grid>
              </Grid>
              <hr className={[classes.breakLineReport]} />
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    className={classNames(classes.title, classes.textCenter)}
                  >
                    {t("report_employee_report")}
                  </Typography>
                  <Typography
                    className={classNames(classes.textCenter, classes.fs14)}
                  >
                    {t("report_report_for")}: <b>{oneEmployee.name}</b> ——{" "}
                    {this.getFormatDate(data.from)} -{" "}
                    {this.getFormatDate(data.to)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={0} className={classNames(classes.mt5)}>
                <div>
                  <Typography
                    className={classNames(classes.textLeft, classes.footer)}
                  >
                    <b>{t("report_position")}:</b> {t("report_staff")}
                  </Typography>
                </div>
                <div className={classNames(classes.ml6)}>
                  <Typography className={classNames(classes.textLeft)}>
                    <b>{t("report_salary")}:</b>{" "}
                    <NumberFormat
                      suffix={` ${setting.currencyCode}`}
                      thousandSeparator={true}
                      displayType={"text"}
                      value={oneEmployee.salary}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid container spacing={24}>
                <Grid item xs={6} sm={6} md={6}>
                  <Grid container spacing={24}>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={1}
                      sm={1}
                      md={1}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_no")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={3}
                      sm={3}
                      md={3}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_order_code")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={6}
                      sm={6}
                      md={6}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_item")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={2}
                      sm={2}
                      md={2}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_quantity")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Grid container spacing={24}>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_date")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_price")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold
                          )}
                        >
                          {t("report_bonus")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold
                          )}
                        >
                          {t("report_commission")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {this.renderRowReport()}
              <Grid container spacing={0} className={classNames(classes.mt1)}>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  className={classNames(classes.footer)}
                >
                  <Typography
                    className={classNames(classes.fs14, classes.textBold)}
                  >
                    {t("report_total_commission")}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography
                    className={classNames(
                      classes.textRight,
                      classes.fs14,
                      classes.textBold
                    )}
                  >
                    <NumberFormat
                      suffix={` ${setting.currencyCode}`}
                      thousandSeparator={true}
                      displayType={"text"}
                      value={this.getTotalBonus()}
                    />
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={0} className={classNames(classes.mt1)}>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  className={classNames(classes.footer)}
                >
                  <Typography>
                    <b className={classNames(classes.fs14, classes.textBold)}>
                      {t("report_total_salary_commission")}
                    </b>{" "}
                    (
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={oneEmployee.salary}
                    />{" "}
                    +{" "}
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={this.getTotalBonus()}
                    />
                    )
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography
                    className={classNames(
                      classes.textRight,
                      classes.fs14,
                      classes.textBold
                    )}
                  >
                    <NumberFormat
                      suffix={` ${setting.currencyCode}`}
                      thousandSeparator={true}
                      displayType={"text"}
                      value={oneEmployee.salary + this.getTotalBonus()}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({
  listOrders: state.report.listOrders,
  totalOrder: state.report.totalOrder,
  setting: state.setting.setting,
  service: state.service.service,
  oneEmployee: state.employees.oneEmployee,
  bonusEmployee: state.employees.bonusEmployee,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EmployeeReport)
  )
);
